import { render, staticRenderFns } from "./chemLicense.vue?vue&type=template&id=2f72a75e"
import script from "./chemLicense.vue?vue&type=script&lang=js"
export * from "./chemLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f72a75e')) {
      api.createRecord('2f72a75e', component.options)
    } else {
      api.reload('2f72a75e', component.options)
    }
    module.hot.accept("./chemLicense.vue?vue&type=template&id=2f72a75e", function () {
      api.rerender('2f72a75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemLicense.vue"
export default component.exports